import type { FC, ReactNode } from 'react'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import Breadcrumbs from '@/components/site/breadcrumbs'
import { breadcrumbSchema } from '@/lib/schema'

export interface LegalSection {
    heading: string
    paragraphs: string[]
}

interface LegalPageProps {
    title: string
    seoTitle: string
    description: string
    path: string
    updated: string
    intro: string
    sections: LegalSection[]
}

const LegalPage: FC<LegalPageProps> = ({ title, seoTitle, description, path, updated, intro, sections }): ReactNode => {
    const crumbs = [{ label: "Home", href: '/' }, { label: title }]

    return (
        <Layout>
            <Seo title={seoTitle} description={description} path={path} jsonLd={[breadcrumbSchema(crumbs, path)]} />

            <article className='mx-auto max-w-3xl px-4 pb-20 pt-8 sm:px-6'>
                <Breadcrumbs items={crumbs} />

                <h1 className='mt-8 text-4xl font-bold sm:text-5xl'>
                    {title}
                </h1>

                <p className='mt-3 text-base text-muted-foreground'>
                    Last updated {updated}
                </p>

                <p className='mt-6 text-lg leading-relaxed'>
                    {intro}
                </p>

                {sections.map(section => (
                    <section key={section.heading} className='mt-10'>
                        <h2 className='text-2xl font-bold'>
                            {section.heading}
                        </h2>

                        {section.paragraphs.map(paragraph => (
                            <p key={paragraph.slice(0, 40)} className='mt-3 text-lg leading-relaxed'>
                                {paragraph}
                            </p>
                        ))}
                    </section>
                ))}
            </article>
        </Layout>
    )
}

export default LegalPage
